<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed"
  id="sidebar1"
  data-coreui-theme="dark"
  visible
>
  <c-sidebar-brand
    [brandFull]="{
      src: logo,
      width: 75,
      height: 60,
      alt: 'Bamboosoft logo'
    }"
    [brandNarrow]="{
      src: 'assets/favicon.ico',
      width: 46,
      height: 46,
      alt: 'Bamboosoft logo'
    }"
    [routerLink]="[]"
  />

  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" />
  </ng-scrollbar>
  <c-sidebar-toggler
    *ngIf="!sidebar1.narrow"
    cSidebarToggle="sidebar1"
    toggle="unfoldable"
  />
</c-sidebar>

<!--aside-->
<app-default-aside style="display: none;" />

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-default-header class="mb-4 d-print-none header header-sticky" data-coreui-theme="dark" position="sticky"
                      sidebarId="sidebar1" />
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <c-container breakpoint="xlg" class="h-auto">
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>
